import { createSlice } from '@reduxjs/toolkit';
import { CostCategory, Project } from '../../models/Project';
import { RootState } from '../store';

interface ProjectState {
  project: Project | null;
  projectList: Project[];
  costCategories: CostCategory[];
}

const initialState: ProjectState = {
  project: null,
  projectList: [],
  costCategories: [],
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProject: (state, action) => {
      state.project = action.payload;
    },
    setProjectList: (state, action) => {
      state.projectList = action.payload;
    },
    setCostCategories: (state, action) => {
      state.costCategories = action.payload;
    },
  },
});

export const { setProject, setProjectList, setCostCategories } = projectSlice.actions;

export default projectSlice.reducer;

export const selectCurrentProject = (state: RootState) => state.project.project;
export const selectCurrentProjectList = (state: RootState) => state.project.projectList;
export const selectCurrentCostCategories = (state: RootState) => state.project.costCategories;
